import BaseClient from '../BaseClient';
import type { AcuityClientInterface, UpdateAcuityGroupMappingParams } from './acuityClient.types';

export default class CorporateAcuityClient extends BaseClient implements AcuityClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getAppointmentTypes() {
        const url = `/api/v3/teams/${this.teamId}/acuity/appointment-types`;
        return this.makeCoreApiRequest(url, 'get');
    }

    getGroupMapping(groupId: string) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/acuity-mapping`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateGroupMapping(groupId: string, data: UpdateAcuityGroupMappingParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/acuity-mapping`;
        return this.makeCoreApiRequest(url, 'patch', data);
    }
}
